import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white">
      <div className="section-container py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-900 text-xs font-bold text-white">
                LY
              </span>
              <span className="font-bold text-slate-900">Lezzet Yolda Toptan</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-600">
              Restoranlar ve toptancılar için güvenilir B2B gıda tedarik platformu. Şeffaf fiyat, hızlı sipariş,
              profesyonel iş ortaklığı.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-900">Platform</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li>
                <Link to="/" className="transition hover:text-brand-600">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="transition hover:text-brand-600">
                  Kategoriler
                </Link>
              </li>
              <li>
                <Link to="/#wholesalers" className="transition hover:text-brand-600">
                  Toptancılar
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition hover:text-brand-600">
                  Arama
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-900">Destek</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li>
                <Link to="/login" className="transition hover:text-brand-600">
                  Giriş Yap
                </Link>
              </li>
              <li>
                <a href="mailto:info@lezzetyolda.com" className="transition hover:text-brand-600">
                  Yardım Merkezi
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-900">İletişim</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li>
                <a href="mailto:info@lezzetyolda.com" className="transition hover:text-brand-600">
                  info@lezzetyolda.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-slate-200 pt-8 md:flex-row">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Lezzet Yolda Toptan. Tüm hakları saklıdır.
          </p>
          <p className="text-xs font-medium text-slate-500">B2B gıda tedarik platformu</p>
        </div>
      </div>
    </footer>
  );
}
